<template>
  <div>
    <HeaderEditorial />
    <main>
      <ErrorBoundary>
        <slot />
      </ErrorBoundary>
    </main>
    <FooterLuxury />
    <JoinListFloatingCta />
  </div>
</template>

<script setup>
// Le breadcrumb sera géré automatiquement par le composant AutoBreadcrumb
// dans chaque page individuellement pour plus de flexibilité
</script>
